export default "__VITE_ASSET__CYzNCOCc__"